import { CoreIcon } from '../core-icon';
import commentSVG from '../../assets/icons/comment.svg';
import type { IconProps } from '../core-icon';

export const CommentIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={commentSVG} {...props} />;
};
